<template>
  <div>
    <ed-form :model="formData">
      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Empresa"
        v-model="formData.id_emp"
        :items="lstEmpresa"
        :loading="loadingEmpresa"
        @input="getFuncionario"
        @search="getEmpresa"
        clearable
        remote
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
        label="Trabalhador"
        v-model="formData.id_fun"
        :items="lstFuncionario"
        :loading="loadingFuncionario"
        @search="getFuncionario"
        clearable
        remote
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
        label="Data de Início do Periodo"
        v-model="formData.data_inicio"
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
        label="Data de Final do Periodo"
        v-model="formData.data_fim"
      />

      <div
        class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12
          text-center
          mt-5
        "
      >
        <ed-button
          type="success"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
          :disabled="
            !formData.id_emp ||
            !formData.id_fun ||
            !formData.data_inicio ||
            !formData.data_fim
              ? true
              : false
          "
          @click="consultar"
        />
      </div>
    </ed-form>

    <div class="col-12 mt-5" v-if="formData.strXml">
      <h4><b>Informações no eSocial</b></h4>

      <XmlViewer :xml="formData.strXml" />
    </div>
  </div>
</template>

<script>
import XmlViewer from "vue-xml-viewer";
import Rest from "common/rest";
import {
  EdForm,
  EdButton,
  EdInputSelect,
  EdInputText,
  EdInputDate,
} from "template";

export default {
  name: "esocial-lotes-reenviar-email",
  mixins: [Rest],
  components: {
    XmlViewer,
    EdForm,
    EdButton,
    EdInputSelect,
    EdInputText,
    EdInputDate,
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: [],
    },
    loadingEmpresa: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function (newVal) {},
      deep: true,
    },
    loadingEmpresa() {},
  },

  data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null,
      },
      lstFuncionario:[],
      loadingFuncionario:false
    };
  },

  created() {},

  mounted() {},

  methods: {
    getFuncionario(_search) {
      if (!this.formData.id_emp) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
      }).then((result) => {
        result = result[0];
        if (result.status == 200) {
          this.lstFuncionario = result.data.data;
        }
        this.loadingFuncionario = false;
      });
    },

    consultar() {
      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request
        .post(
          "esocial/lotes/consultar/" +
            this.formData.id_emp +"/"+this.formData.id_fun +
            "/evento-funcionario",
          this.formData
        )
        .then((result) => {
          this.$root.$loading.set(false);

          console.log("result", result);
          if (result.status == 200) {
            this.formData.strXml = result.data;
          } else {
            // this.$alert(result.msg, "Atenção", {
            //   confirmButtonText: "OK",
            // });
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// consulta-evento-trabalhador.vue?7b5d28b4